import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';

import Icon from './Icon';

/**
 * Figure
 */

class Figure extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.number = Number(this.props.number);
    this.play = () => this.setState({ isPlaying: true });
    this.paused = () => !this.state.isPlaying;

    /** State */
    this.state = { isPlaying: this.props.play };
  }

  render() {
    const layoutClass = this.props.dots ? 'l-dots' : '';
    const colorClass = `${this.props.dots ? 'dots' : 'text'}-${this.props.color}`;
    const textColorClass = this.props.textColor ? `text-${this.props.textColor}` : '';
    const iconColorClass = this.props.iconColor ? `text-${this.props.iconColor}` : '';
    const countClass = this.props.count ? 'l-count' : '';
    const FigureIcon = this.props.icon ? <Icon icon={this.props.icon} layout={`figure-icon ${iconColorClass}`} /> : <></>;
    return (
      <>
        <strong className={`figure ${layoutClass} ${colorClass} ${countClass} text-${textColorClass}`}>
          {this.props.icon && (
            <>
              {this.props.link ? (
                <a className="figure-link" href={this.props.link.url} target="_blank" rel="noopener noreferrer">
                  {FigureIcon}
                </a>
              ) : (
                <>{FigureIcon}</>
              )}
            </>
          )}
          {this.props.prefix && <span className="figure-prefix">{this.props.prefix}</span>}
          {this.state.isPlaying ? (
            <CountUp className="figure-count" end={this.number} duration={4.75} decimals={this.number % 1 === 0 ? 0 : 2} decimal="." separator="," />
          ) : (
            <span className="figure-count">0</span>
          )}
          {this.props.suffix && <span className="figure-suffix">{this.props.suffix}</span>}
        </strong>
        {this.props.text && (
          <span dangerouslySetInnerHTML={{ __html: this.props.text }} className={`figure-text ${textColorClass} strong-${this.props.color}`} />
        )}
      </>
    );
  }
}

Figure.propTypes = {
  number: PropTypes.number.isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  color: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  play: PropTypes.bool,
  dots: PropTypes.bool,
  text: PropTypes.string,
  textColor: PropTypes.string,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
  }),
  count: PropTypes.bool,
};

export default Figure;
